<template>
    <div id="supplierPage">
      <img src="../../assets/admin/images/iran.png" id="iranImage" alt="">
      <!-- <button id="supplierMessageIcon" @click="showMessage=!showMessage">
<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" id="Capa_1" x="0px" y="0px" width="510px" height="510px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve" inkscape:version="0.91 r13725" sodipodi:docname="notification_logo.svg"><metadata id="metadata42"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs40"/><sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10" gridtolerance="10" guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2" inkscape:window-width="1920" inkscape:window-height="1145" id="namedview38" showgrid="false" inkscape:zoom="0.4627451" inkscape:cx="-282.01271" inkscape:cy="255" inkscape:window-x="0" inkscape:window-y="27" inkscape:window-maximized="1" inkscape:current-layer="Capa_1"/><g id="g3" transform="matrix(0.87658593,0,0,0.87658593,31.470588,31.470588)"><g id="notifications"><path d="m 255,510 c 28.05,0 51,-22.95 51,-51 l -102,0 c 0,28.05 22.95,51 51,51 z m 165.75,-153 0,-140.25 C 420.75,137.7 367.2,73.95 293.25,56.1 l 0,-17.85 C 293.25,17.85 275.4,0 255,0 234.6,0 216.75,17.85 216.75,38.25 l 0,17.85 C 142.8,73.95 89.25,137.7 89.25,216.75 l 0,140.25 -51,51 0,25.5 433.5,0 0,-25.5 -51,-51 z" id="path6" inkscape:connector-curvature="0"/></g></g><g id="g8"/><g id="g10"/><g id="g12"/><g id="g14"/><g id="g16"/><g id="g18"/><g id="g20"/><g id="g22"/><g id="g24"/><g id="g26"/><g id="g28"/><g id="g30"/><g id="g32"/><g id="g34"/><g id="g36"/></svg>

      </button> -->
      <!-- <div v-if="showMessage"  id="supplierMessageSideBar">
        <div id="messageHeaderBox">
          <svg
          @click="showMessage=!showMessage"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:ns1="http://sozi.baierouge.fr"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    id="svg2"
    viewBox="0 0 744.09 1052.4"
    version="1.1"
  >
  <g
      id="layer1"
    >
    <path
        id="path2989"
        d="m814.29 606.65a314.29 314.29 0 1 1 -628.57 0 314.29 314.29 0 1 1 628.57 0z"
        stroke="#000"
        stroke-width="5"
        transform="matrix(1.1048 0 0 1.1048 -179.21 -162.53)"
    />
    <g
        id="g3763"
        transform="matrix(.91837 0 0 .91837 47.587 10.944)"
        stroke="#fff"
        stroke-linecap="round"
        stroke-width="133.87"
        fill="none"
      >
      <path
          id="path2991"
          d="m176.51 362.87 356.13 356.13"
      />
      <path
          id="path2993"
          d="m532.64 362.87-356.13 356.13"
      />
    </g
    >
  </g
  >
  <metadata
    >
    <rdf:RDF
      >
      <cc:Work
        >
        <dc:format
          >image/svg+xml</dc:format
        >
        <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage"
        />
        <cc:license
            rdf:resource="http://creativecommons.org/licenses/publicdomain/"
        />
        <dc:publisher
          >
          <cc:Agent
              rdf:about="http://openclipart.org/"
            >
            <dc:title
              >Openclipart</dc:title
            >
          </cc:Agent
          >
        </dc:publisher
        >
        <dc:title
          >Close Button</dc:title
        >
        <dc:date
          >2013-09-18T11:23:45</dc:date
        >
        <dc:description
          >A round black close button with a white, thick, X in the center.</dc:description
        >
        <dc:source
          >https://openclipart.org/detail/183568/close-button-by-henrikhoff-183568</dc:source
        >
        <dc:creator
          >
          <cc:Agent
            >
            <dc:title
              >henrikhoff</dc:title
            >
          </cc:Agent
          >
        </dc:creator
        >
        <dc:subject
          >
          <rdf:Bag
            >
            <rdf:li
              >black</rdf:li
            >
            <rdf:li
              >close button</rdf:li
            >
            <rdf:li
              >cross</rdf:li
            >
            <rdf:li
              >icon</rdf:li
            >
            <rdf:li
              >white</rdf:li
            >
            <rdf:li
              >x</rdf:li
            >
          </rdf:Bag
          >
        </dc:subject
        >
      </cc:Work
      >
      <cc:License
          rdf:about="http://creativecommons.org/licenses/publicdomain/"
        >
        <cc:permits
            rdf:resource="http://creativecommons.org/ns#Reproduction"
        />
        <cc:permits
            rdf:resource="http://creativecommons.org/ns#Distribution"
        />
        <cc:permits
            rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
        />
      </cc:License
      >
    </rdf:RDF
    >
  </metadata
  >
</svg
>
<span>
پیام های ارسالی از سمت مدیریت

</span>
        </div>
          <ul v-if="items&&items.length" id="messageContent">

          <li v-for="item in items" :key="item.id">
            <p>
              {{item.message}}
            </p>
            <span>
              {{item.createDate}}
            </span>
          </li>
        </ul>

        <div v-else>
          در حال حاضر پیامی وجود ندارد
        </div>
      </div> -->
    <router-view></router-view>
    </div>
  </template>
  <script>
  // import the styles
  import adminMixin from "@/libraries/adminController.js";
  import { BModal, BButton, BOverlay, BSpinner } from "bootstrap-vue";
  export default {
    mixins: [adminMixin],
    components: {
      BModal,
      BButton,
      BOverlay,
      BSpinner,
    },
    data() {
      return {
        showMessage:false,
        items: null,
      };
    },
    mounted() {
      // this.$axios
      //   .get("SupplierMessage/GetUserMessage")
      //   .then((res) => {
      //     this.items = res.data.data;
      //   })
        // .catch((err) => {
        //   this.$toast.error(err.response.data.message);
        // });
    },
  };
  </script>
  <style>
  div#userRole {
    width: 90%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    margin: auto;
  }
  .message .date {
    position: absolute;
    left: 0;
    top: 0;
    padding: 5px;
}
.message {
    box-shadow: 0 0 5px #1213;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    direction: rtl;
    position: relative;
}
div#supplierPage {
  width: 100%;
  position: relative;
}
button#supplierMessageIcon path {
  fill: #edc739;
}
button#supplierMessageIcon svg {
  width: 60px;
  height: 60px;
}
button#supplierMessageIcon {
  background: transparent;
  border: none;
  position: absolute;
  left: 10px;
  top: 10px;
}
div#messageHeaderBox svg {
  width: 30px;
}
div#messageHeaderBox {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-bottom: 1px solid grey;
  height: 80px;
}
div#supplierMessageSideBar {
  position: fixed;
  height: 100vh;
  background: white;
  box-shadow: 0 0 5pc #303030ab;
  min-width: 350px;
  left: 0;
  top: 0;
  animation: sideBar 0.7s linear forwards;
}
@keyframes sideBar{
  from{
    left: -350px;
  }
  to{
    left: 0;
  }
}
ul#messageContent li::marker {
  color: #5fff00;
  font-size: x-large;
}
ul#messageContent li span {
  color: #001a3e8f;
}

ul#messageContent li {
  border-bottom: 1px solid #1213;
}
ul#messageContent li p {
  text-align: right;
  direction: rtl;
}
ul#messageContent {
  list-style: inherit;
  padding: 24px;
  direction: rtl;
  height: calc(100vh - 80px);
    overflow: auto;
}
img#iranImage {
  position: fixed;
  left: 0;
  top: 0;
  width: 15%;
}
  </style>
  